import {
  Component,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
} from "@angular/core";
import { NavigationEnd, Router } from "@angular/router";
import { BehaviorSubject, Observable, fromEvent } from "rxjs";

import { LayoutConfigModel } from "../app/interfaces/home/layout-config";

// Config
import { LayoutConfig } from "./config/layout.config";
import { HtmlClassService } from "../app/services/home/html-class.service";
import { TranslationService } from "../app/services/home/translation.service";
import { SplashScreenService } from "../app/services/home/splash-screen.service";
import { NgProgress } from "ngx-progressbar";

import * as objectPath from "object-path";
import { Subscription } from "rxjs";

// language list
import { locale as enLang } from "./config/i18n/en";
import { locale as arLang } from "./config/i18n/ar";


//LOAD LANGUAGES IN STORE

import { FireBaseService } from '../app/services/fireBase-service/fire-base.service';
import { SnackbarService } from "./services/home/snackbar.service";
import { fadeOut } from "./animations/template.animations";

export interface ClassType {
  header: string[];
  header_mobile: string[];
  header_menu: string[];
  aside_menu: string[];
  aside: string[];
}

@Component({
  selector: "body[app-root]",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.css"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [fadeOut]
})
export class AppComponent {
  title = "Etloob";
  config: LayoutConfigModel;
  loader: boolean;
  private unsubscribe: Subscription[] = [];
  classes: ClassType;
  onClassesUpdated$: BehaviorSubject<ClassType>;
  selectedTheme: string;

  // currentMessage = new BehaviorSubject(null);

  offlineEvent: Observable<Event>;
  onlineEvent: Observable<Event>;
  subscriptions: Subscription[] = [];
  isOnline: boolean = true;

  constructor(
    private router: Router,
    public progress: NgProgress,
    private htmlClassService: HtmlClassService,
    private translationService: TranslationService,
    private splashScreenService: SplashScreenService,
    private fireBaseService : FireBaseService,
    private snackbarService: SnackbarService,
    private changeDetectionRef: ChangeDetectorRef,
  ) {
    // register translations
    this.translationService.loadTranslations(
      enLang,
      arLang,
    );
  }

  ngOnInit() {
    
    let config = new LayoutConfig().defaults;
    if (config) {
      localStorage.setItem("layoutConfig", JSON.stringify(config));
    }
    this.htmlClassService.setConfig(new LayoutConfig().configs);

    this.loader = objectPath.get(config, "loader.enabled");

    const routerSubscription = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        // hide splash screen
        this.splashScreenService.hide();

        // scroll to top on every route change
        window.scrollTo(0, 0);

        // to display back the body content
        setTimeout(() => {
          document.body.classList.add("kt-page--loaded");
        }, 1000);
      }
    });
    this.unsubscribe.push(routerSubscription);
    this.fireBaseService.requestPermission();
    this.fireBaseService.receiveMessage();
    this.handleAppConnectivityChanges();
  }

  getTheme(theme: string) {
    this.selectedTheme = theme;
  }


  private handleAppConnectivityChanges(): void {
    this.onlineEvent = fromEvent(window, 'online');
    this.offlineEvent = fromEvent(window, 'offline');

    this.subscriptions.push(this.onlineEvent.subscribe(e => {
      // handle online mode
      this.isOnline = true;
      this.snackbarService.openSnackBar('You Are Online!', '', 'Info');
       !this.changeDetectionRef["destroyed"]
        ? this.changeDetectionRef.detectChanges()
        : null;
    }));

    this.subscriptions.push(this.offlineEvent.subscribe(e => {
      // handle offline mode
      this.isOnline = false;
      this.snackbarService.openSnackBar('You Are Offline!', '', 'Info');
       !this.changeDetectionRef["destroyed"]
        ? this.changeDetectionRef.detectChanges()
        : null;
    }));
  }


  ngOnDestroy() {
    this.unsubscribe.forEach((sb) => sb.unsubscribe());
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }

}
